const StripeCard = require("components/abstract/StripeCard");
const {classList} = require("helpers/html");

class CreditCard extends StripeCard {

	setError(message) {
		this.setState({error: message});
	}

	renderError() {
		if (this.state.error) {
			return (<p className="error">{this.state.error}</p>);
		}
	}

	render() {
		const className = classList(
			"credit-card",
			this.props.className
		);

		return (
			<div className={className}>
				{this.renderBody()}
				{this.renderError()}
				{this.renderToken()}
			</div>
		);
	}

}

module.exports = CreditCard;


// WEBPACK FOOTER //
// ./resources/js/components/checkout/CreditCard.js